// extracted by mini-css-extract-plugin
export default {"LDtitle":"LiveDepartures_LDtitle__YnfNi"};